import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
} from '@angular/router';
import {
	Asset,
	Company,
	urlIdentifierToCompanyName,
} from 'company-finder-common';
import { Logger } from '../utilities/logger/logger.js';
import { AssetService } from '../services/asset/asset.service.js';
import { CompanyService } from '../services/index.js';

@Injectable({ providedIn: 'root' })
export class AssetResolver {
	protected _logger = new Logger(this.constructor.name);

	constructor(
		private assetService: AssetService,
		private companyService: CompanyService,
		private router: Router
	) {}

	async resolve(
		route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Promise<{ asset: Asset; company: Company }> {
		try {
			const name = urlIdentifierToCompanyName(route.params.name);

			if (!name) {
				this.router.navigate(['/']);
			}

			const asset = await this.assetService.getByName(name);

			if (!asset) {
				this.router.navigate(['/']);
			}
			const company = await this.companyService.getByNameOrOppId(
				asset.companyName
			);

			return { asset, company };
		} catch (error) {
			this._logger.warn(`Asset resolver failed: ${error}`);
			this.router.navigate(['/']);
		}
	}
}
